import WelcomeHeader from './WelcomeHeader';

export default WelcomeHeader;
